import type { PaginationMeta } from '@/types'

export const WAREHOUSE_LOOKUP_TABLES = [
  'tariff_rates',
  'freight_rates',
  'cost_to_serve',
  'freight_n_whse_inbound',
  'freight_n_whse_outbound',
  'freight_n_whse_upcharge',
  'other_import_rate',
  'canada_pricing',
] as const

export type WarehouseLookupTableName = (typeof WAREHOUSE_LOOKUP_TABLES)[number]

export interface WarehouseLookupTableSummary {
  table_name: WarehouseLookupTableName
  entry_count: number
  active_count: number
}

export interface WarehouseLookupEntry {
  id: string
  table_name: WarehouseLookupTableName
  lookup_key: string
  value_text: string | null
  value_num: number | null
  is_active: boolean
  created_at: string
  updated_at: string
}

export interface PaginatedWarehouseLookupEntriesResponse {
  data: WarehouseLookupEntry[]
  pagination: PaginationMeta
}

export interface WarehouseLookupListParams {
  skip?: number
  limit?: number
  search?: string
}

export interface WarehouseLookupCreatePayload {
  lookup_key: string
  value_text?: string | null
  value_num?: number | null
}

export interface WarehouseLookupUpdatePayload {
  lookup_key?: string
  value_text?: string | null
  value_num?: number | null
  is_active?: boolean
}

export interface WarehouseLookupBulkUpsertPayload {
  entries: WarehouseLookupCreatePayload[]
}

export interface WarehouseLookupEntryUsage {
  lookup_key: string
  plan_count: number
  line_item_count: number
}

export const CANADA_PRICING_TABLE = 'canada_pricing' as const

export const CANADA_PRICING_KEYS = {
  cadUsdRate: 'CAD_USD_RATE',
  costOfDoingBusiness: 'COST_OF_DOING_BUSINESS',
} as const

/** Backend fallbacks used when a canada_pricing row is missing or inactive. */
export const CANADA_PRICING_DEFAULTS = {
  cadUsdRate: 0.7,
  costOfDoingBusiness: 0.31,
} as const
